<script setup lang="ts">
import FilePreviewGroup from '@/components/files/FilePreviewGroup.vue';
import Link from '@/components/Link.vue';
import type { NoteCreatedByFullName } from '@/types/actionPoint';
import type { File } from '@/types/files';
import { toDisplayDate } from '@/utils/date';

const props = defineProps<{
    note: NoteCreatedByFullName;
    files: File[];
    actionPointId: string;
}>();
</script>

<template>
    <section class="note-component border rounded-lg">
        <div class="d-flex align-center px-3 py-1 justify-space-between bg-main rounded-lg rounded-b-0">
            <h5 class="ma-0 pa-0 d-flex align-center ga-1 text-white">
                <v-icon icon="sticky_note_2" class="text-white" />
                {{ props.note.title }}
            </h5>
            <div class="d-flex align-center ga-5">
                <Link
                    v-if="props.note.createdBy"
                    :route-to="{ name: 'employee', params: { id: note.createdBy._id } }"
                    :display-text="note.createdBy.fullName"
                    icon="person"
                    icon-class="text-white"
                    span-class="text-white"
                />
                <span v-if="props.note.createdOn" class="text-white">
                    {{ toDisplayDate(props.note.createdOn, true) }}
                </span>
                <span v-else class="text-white">Onbekende datum</span>
            </div>
        </div>

        <div class="pa-3">
            <p class="note-body pa-0 ma-0 pb-5">
                {{ props.note.body }}
            </p>
            <FilePreviewGroup v-if="props.files.length > 0" :files="props.files" :actionPointId="props.actionPointId" />
        </div>
    </section>
</template>

<style scoped>
.note-body {
    white-space: pre-wrap;
    font-size: 15px;
}
</style>
